"use strict";

require("core-js/modules/es.array.reduce");

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Right = exports.Left = exports.Either = void 0;

var Maybe_1 = require("./Maybe");

exports.Either = {
  of: function of(value) {
    return right(value);
  },
  lefts: function lefts(list) {
    var e_1, _a;

    var result = [];

    try {
      for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
        var x = list_1_1.value;

        if (x.isLeft()) {
          result.push(x.extract());
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return result;
  },
  rights: function rights(list) {
    var e_2, _a;

    var result = [];

    try {
      for (var list_2 = __values(list), list_2_1 = list_2.next(); !list_2_1.done; list_2_1 = list_2.next()) {
        var x = list_2_1.value;

        if (x.isRight()) {
          result.push(x.extract());
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (list_2_1 && !list_2_1.done && (_a = list_2.return)) _a.call(list_2);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return result;
  },
  encase: function encase(throwsF) {
    try {
      return right(throwsF());
    } catch (e) {
      return left(e);
    }
  },
  sequence: function sequence(eithers) {
    var e_3, _a;

    var res = [];

    try {
      for (var eithers_1 = __values(eithers), eithers_1_1 = eithers_1.next(); !eithers_1_1.done; eithers_1_1 = eithers_1.next()) {
        var e = eithers_1_1.value;

        if (e.isLeft()) {
          return e;
        }

        res.push(e.extract());
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (eithers_1_1 && !eithers_1_1.done && (_a = eithers_1.return)) _a.call(eithers_1);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return right(res);
  },
  isEither: function isEither(x) {
    return x instanceof Left || x instanceof Right;
  },
  'fantasy-land/of': function fantasyLandOf(value) {
    return exports.Either.of(value);
  }
};

var Right =
/** @class */
function () {
  function Right(__value) {
    this.__value = __value;
    this._ = 'R';
    this['fantasy-land/bimap'] = this.bimap;
    this['fantasy-land/map'] = this.map;
    this['fantasy-land/ap'] = this.ap;
    this['fantasy-land/equals'] = this.equals;
    this['fantasy-land/chain'] = this.chain;
    this['fantasy-land/alt'] = this.alt;
    this['fantasy-land/reduce'] = this.reduce;
    this['fantasy-land/extend'] = this.extend;
  }

  Right.prototype.isLeft = function () {
    return false;
  };

  Right.prototype.isRight = function () {
    return true;
  };

  Right.prototype.toJSON = function () {
    return this.__value;
  };

  Right.prototype.inspect = function () {
    return "Right(" + JSON.stringify(this.__value) + ")";
  };

  Right.prototype.toString = function () {
    return this.inspect();
  };

  Right.prototype.bimap = function (_, g) {
    return right(g(this.__value));
  };

  Right.prototype.map = function (f) {
    return right(f(this.__value));
  };

  Right.prototype.mapLeft = function (_) {
    return this;
  };

  Right.prototype.ap = function (other) {
    return other.isRight() ? this.map(other.extract()) : other;
  };

  Right.prototype.equals = function (other) {
    return other.isRight() ? this.__value === other.extract() : false;
  };

  Right.prototype.chain = function (f) {
    return f(this.__value);
  };

  Right.prototype.chainLeft = function (_) {
    return this;
  };

  Right.prototype.join = function () {
    return this.__value;
  };

  Right.prototype.alt = function (_) {
    return this;
  };

  Right.prototype.reduce = function (reducer, initialValue) {
    return reducer(initialValue, this.__value);
  };

  Right.prototype.extend = function (f) {
    return right(f(this));
  };

  Right.prototype.unsafeCoerce = function () {
    return this.__value;
  };

  Right.prototype.caseOf = function (patterns) {
    return '_' in patterns ? patterns._() : patterns.Right(this.__value);
  };

  Right.prototype.leftOrDefault = function (defaultValue) {
    return defaultValue;
  };

  Right.prototype.orDefault = function (_) {
    return this.__value;
  };

  Right.prototype.orDefaultLazy = function (_) {
    return this.__value;
  };

  Right.prototype.leftOrDefaultLazy = function (getDefaultValue) {
    return getDefaultValue();
  };

  Right.prototype.ifLeft = function (_) {
    return this;
  };

  Right.prototype.ifRight = function (effect) {
    return effect(this.__value), this;
  };

  Right.prototype.toMaybe = function () {
    return Maybe_1.Just(this.__value);
  };

  Right.prototype.leftToMaybe = function () {
    return Maybe_1.Nothing;
  };

  Right.prototype.either = function (_, ifRight) {
    return ifRight(this.__value);
  };

  Right.prototype.extract = function () {
    return this.__value;
  };

  Right.prototype.swap = function () {
    return left(this.__value);
  };

  return Right;
}();

Right.prototype.constructor = exports.Either;

var Left =
/** @class */
function () {
  function Left(__value) {
    this.__value = __value;
    this._ = 'L';
    this['fantasy-land/bimap'] = this.bimap;
    this['fantasy-land/map'] = this.map;
    this['fantasy-land/ap'] = this.ap;
    this['fantasy-land/equals'] = this.equals;
    this['fantasy-land/chain'] = this.chain;
    this['fantasy-land/alt'] = this.alt;
    this['fantasy-land/reduce'] = this.reduce;
    this['fantasy-land/extend'] = this.extend;
  }

  Left.prototype.isLeft = function () {
    return true;
  };

  Left.prototype.isRight = function () {
    return false;
  };

  Left.prototype.toJSON = function () {
    return this.__value;
  };

  Left.prototype.inspect = function () {
    return "Left(" + JSON.stringify(this.__value) + ")";
  };

  Left.prototype.toString = function () {
    return this.inspect();
  };

  Left.prototype.bimap = function (f, _) {
    return left(f(this.__value));
  };

  Left.prototype.map = function (_) {
    return this;
  };

  Left.prototype.mapLeft = function (f) {
    return left(f(this.__value));
  };

  Left.prototype.ap = function (other) {
    return other.isLeft() ? other : this;
  };

  Left.prototype.equals = function (other) {
    return other.isLeft() ? other.extract() === this.__value : false;
  };

  Left.prototype.chain = function (_) {
    return this;
  };

  Left.prototype.chainLeft = function (f) {
    return f(this.__value);
  };

  Left.prototype.join = function () {
    return this;
  };

  Left.prototype.alt = function (other) {
    return other;
  };

  Left.prototype.reduce = function (_, initialValue) {
    return initialValue;
  };

  Left.prototype.extend = function (_) {
    return this;
  };

  Left.prototype.unsafeCoerce = function () {
    if (this.__value instanceof Error) {
      throw this.__value;
    }

    throw new Error('Either#unsafeCoerce was ran on a Left');
  };

  Left.prototype.caseOf = function (patterns) {
    return '_' in patterns ? patterns._() : patterns.Left(this.__value);
  };

  Left.prototype.leftOrDefault = function (_) {
    return this.__value;
  };

  Left.prototype.orDefault = function (defaultValue) {
    return defaultValue;
  };

  Left.prototype.orDefaultLazy = function (getDefaultValue) {
    return getDefaultValue();
  };

  Left.prototype.leftOrDefaultLazy = function (_) {
    return this.__value;
  };

  Left.prototype.ifLeft = function (effect) {
    return effect(this.__value), this;
  };

  Left.prototype.ifRight = function (_) {
    return this;
  };

  Left.prototype.toMaybe = function () {
    return Maybe_1.Nothing;
  };

  Left.prototype.leftToMaybe = function () {
    return Maybe_1.Just(this.__value);
  };

  Left.prototype.either = function (ifLeft, _) {
    return ifLeft(this.__value);
  };

  Left.prototype.extract = function () {
    return this.__value;
  };

  Left.prototype.swap = function () {
    return right(this.__value);
  };

  return Left;
}();

Left.prototype.constructor = exports.Either;

var left = function left(value) {
  return new Left(value);
};

exports.Left = left;

var right = function right(value) {
  return new Right(value);
};

exports.Right = right;